/**
 * GEN-PX-033 · Saber precargado. Caché en memoria del cliente (nada de localStorage) con lo que Saber pinta al abrir:
 * el resumen de GET /v1/ekb/saber («Lo que sabemos») y los encargos de GET /v1/ekb/encargos («Lo último de Jimmy»).
 * Se llena al entrar en el Pórtico y en cada lectura de Saber (stale-while-revalidate: se pinta lo guardado y se vuelve a
 * pedir). Es la misma llamada autenticada de siempre, así que solo guarda lo que el perfil puede ver; va ligada a la persona y
 * se vacía al cerrar sesión.
 */
import { getSaber, listEncargos } from '../api/client.js'

let dueno = null
let saber = null
let encargos = null

const para = clave => {
  if (clave !== dueno) { dueno = clave; saber = null; encargos = null }
}

export const claveDe = user => user?.email ?? user?.id ?? null

export function limpiarSaber() { dueno = null; saber = null; encargos = null }

export function saberGuardado(clave) { return clave && clave === dueno ? saber : null }
export function encargosGuardados(clave) { return clave && clave === dueno ? encargos : null }

export function guardarSaber(clave, r) { if (clave && r) { para(clave); saber = r } return r }
export function guardarEncargos(clave, r) { if (clave && r) { para(clave); encargos = r } return r }

/** Pide el resumen y lo guarda; con `clave` null (sin sesión) solo lo pide. */
export function pedirSaber(clave) { return getSaber().then(r => guardarSaber(clave, r)) }
export function pedirEncargos(clave) { return listEncargos().then(r => guardarEncargos(clave, r)) }

/** Al entrar en el Pórtico: en segundo plano, sin bloquear nada ni avisar si falla (Saber lo volverá a pedir). */
export function precargarSaber(clave) {
  if (!clave) return
  para(clave)
  for (const pedir of [pedirSaber, pedirEncargos]) {
    try { pedir(clave).catch(() => {}) } catch { /* sin cliente: no hay nada que precargar */ }
  }
}
